import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class SortDropdownClientDocument extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                <ButtonToolbar className = "btnToolbarSortMultipleExc pull-right" >
                    <DropdownButton
                          bsStyle="default"
                          title="Sort by"
                          noCaret
                          pullRight
                          id="dropdown-no-caret"
                          className="btnToolbarSortMultipleExc"
                          onSelect={this.props.sortResults}
                    >
                        <MenuItem eventKey="1"
                                  className="menuItemToolbarAddMultipleExc">
                            Filename: Asc
                        </MenuItem>
                        <MenuItem eventKey="2"
                                  className="menuItemToolbarAddMultipleExc">
                            Filename: Desc
                        </MenuItem>
                        <MenuItem eventKey="3"
                                  className="menuItemToolbarAddMultipleExc">
                            Date Created: Asc
                        </MenuItem>
                        <MenuItem eventKey="4"
                                  className="menuItemToolbarAddMultipleExc">
                            Date Created: Desc
                        </MenuItem>
                    </DropdownButton>
                </ButtonToolbar>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/SortDropdownClientDocument.js